import { NavigationItem } from '../context/current-context.model';
import { resolvePlacement } from './navigation-placement';
import { PLACEHOLDER_SCREEN_DEFS } from './navigation-placeholder-manifest';
import { IMPLEMENTED_PLACEHOLDER_PATHS } from './navigation-placeholder-claims';

/**
 * Suites that exist only as planned placeholders (no product module yet).
 * Hidden from default Admin wayfinding (SS-4). Deep-link routes still render
 * PlannedModulePlaceholderComponent. Do not add live products here
 * (Insurance, Sales, Catalog, Growth, Finance, Workflow, Platform, …).
 */
export const UNBUILT_NAV_SUITE_KEYS = new Set<string>([
  'banking',
  'card-switch',
  'investment',
  'people',
  'analytics',
  'smart-city'
]);

/**
 * Modules that are 100% placeholder (no Admin feature folder / live supplemental).
 * Do not add mixed modules (catalog, growth, event-hub, knowledge-hub, iot-hub,
 * platform-localization, subscription-billing, ncx-comms, notifications).
 */
export const UNBUILT_NAV_MODULE_KEYS = new Set<string>([
  'digital-twin',
  'platform-integrations',
  'organization-management',
  'platform-ai',
  'ticketing',
  'theming',
  'media-library',
  'mobile-api',
  'social-integrations',
  'shipping',
  'fulfillment',
  'tax'
]);

const PLACEHOLDER_ROUTES = new Set(PLACEHOLDER_SCREEN_DEFS.map(d => `/${d.path}`));

export function isUnbuiltSuiteNavItem(item: NavigationItem): boolean {
  const placement = resolvePlacement(item);
  const suiteKey = item.suiteKey ?? placement.suiteKey;
  const moduleKey = item.moduleKeyCanonical ?? placement.moduleKey;
  if (UNBUILT_NAV_SUITE_KEYS.has(suiteKey) || UNBUILT_NAV_MODULE_KEYS.has(moduleKey)) {
    return true;
  }

  const route = normalizeNavRoute(item.route);
  if (!PLACEHOLDER_ROUTES.has(route)) {
    return false;
  }

  return !IMPLEMENTED_PLACEHOLDER_PATHS.has(route.slice(1));
}

function normalizeNavRoute(route: string): string {
  const path = route.split(/[?#]/)[0] ?? route;
  return path.startsWith('/') ? path : `/${path}`;
}
